import loadable from '@loadable/component';

export const AsyncPhoneCode = loadable(() => import('./PhoneCode'));
